import accountingAccountingFR from './messages/accounting/accounting.json';
import accountingChargeFR from './messages/accounting/charge.json';
import accountingReportingFR from './messages/accounting/reporting.json';
import accountingStatementFR from './messages/accounting/statement.json';
import agencyRatesFR from './messages/agencyRates.json';
import communicationsFR from './messages/communications.json';
import contactFR from './messages/contact.json';
import enumsFR from './messages/enums.json';
import foldersFR from './messages/folders.json';
import leaseAddLeaseFR from './messages/lease/addLease.json';
import leaseDetailFR from './messages/lease/detail.json';
import leaseLeaseFR from './messages/lease/lease.json';
import remainingMessagesFR from './messages/messages.json';
import myCompanyFR from './messages/myCompany.json';
import paymentsFR from './messages/payments.json';
import rentalUnitFR from './messages/rentalUnit.json';
import settingsFR from './messages/settings.json';
import templatesFR from './messages/templates.json';
import transactionsFR from './messages/transactions.json';

export const BackendMessagesFR = {
  accounting: {
    statement: accountingStatementFR,
    reporting: accountingReportingFR,
    charge: accountingChargeFR,
    ...accountingAccountingFR,
  },
  agencyRates: agencyRatesFR,
  communications: communicationsFR,
  contact: contactFR,
  enums: enumsFR,
  folders: foldersFR,
  lease: {
    ...leaseLeaseFR,
    detail: leaseDetailFR,
    addLease: leaseAddLeaseFR,
  },
  myCompany: myCompanyFR,
  rentalUnit: rentalUnitFR,
  settings: settingsFR,
  templates: templatesFR,
  payments: paymentsFR,
  transactions: transactionsFR,
  ...remainingMessagesFR,
};
